import { INITIAL_USER } from '@/utils/constants';

export function setState(state, [field, value]) {
  state[field] = value;
}

export function clearUserData(state) {
  state.fullName = null;
  state.email = null;
  state.auth0Error = null;
  state.user = { ...INITIAL_USER };
}

export function setEmail(state, value) {
  state.email = value;
  state.auth0Error = null;
}

export function setAuthError(state, msg) {
  state.auth0Error = msg;
}

export function setUser(state, user) {
  state.user = { ...user };
}

export function clearResetPasswordData(state) {
  state.email = null;
  state.sendingPasswordEmail = false;
  state.resetPasswordEmailError = undefined;
  state.sendingResetPassword = false;
  state.resetPasswordError = undefined;
}

export function setResetPasswordEmailError(state, error) {
  state.resetPasswordEmailError = error;
}

export function setResetPasswordError(state, error) {
  state.resetPasswordError = error;
}

export function setUserOrganisations(state, organisations) {
  state.userOrganisations = [...organisations];
}

export function setORGBranding(state, branding = {}) {
  state.ORGBranding = branding;
}
